import axios from 'axios';
import { CreatePlantInput } from 'views/feed-management/features/plants/types/create-plant-input.type';
import { Plant } from 'views/feed-management/features/plants/types/plant.type';

// PUT
// Update plant.
// /ewosapi/v1/bestmix/plant/{code}
export const putFeedManagementPlant = async (request: CreatePlantInput): Promise<Plant> => {
  const res = await axios.put<Plant>(`/ewosapi/v1/bestmix/plant/${request.code}`, {
    name: request.name,
    markets: request.markets,
  });
  return res.data;
};
